"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var info_1 = require("../api/info");

var poll_1 = require("./poll");

function isReadyPoll(_a) {
  var file = _a.file,
      publicKey = _a.publicKey,
      baseURL = _a.baseURL,
      source = _a.source,
      integration = _a.integration,
      retryThrottledRequestMaxTimes = _a.retryThrottledRequestMaxTimes,
      cancel = _a.cancel,
      onProgress = _a.onProgress;
  return poll_1.poll({
    check: function check(cancel) {
      return info_1.default(file, {
        publicKey: publicKey,
        baseURL: baseURL,
        cancel: cancel,
        source: source,
        integration: integration,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes
      }).then(function (response) {
        if (response.isReady) {
          return response;
        }

        onProgress && onProgress({
          value: 1
        });
        return false;
      });
    },
    cancel: cancel
  });
}

exports.isReadyPoll = isReadyPoll;